<template>
  <div class="overlay" v-show="display">
    <div class="modal">
      <i class="el-icon-close" @click="closeDisplay"></i>
      <h3>感谢您的关注。</h3>
      <p>为了能更好地向您介绍产品，请留下您的联系方式。我们的专业顾问会在1个工作日内与您联系，请保持电话畅通。</p>
      <input type="text" placeholder="请输入您的姓名" v-model="name" />
      <input type="text" placeholder="请输入您的电话" v-model="phone" />
      <button @click="submit">提交</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      phone: '',
      overlay: true
    };
  },
  
  props: {
      display: {
          type: Boolean,
          default: true,
      }
  },
  methods: {
    
    isPhone(s){
      const mobilePattern = /^(1[3-9])\d{9}$/; // 手机号码模式
      const landlinePattern = /^0\d{2,3}-\d{7,8}$/; // 座机号码模式
      
      return mobilePattern.test(s) || landlinePattern.test(s);
    },
    submit() {
      const h = this.$createElement;

      if (!this.isPhone(this.phone)) {
          this.$message.error('请输入正确的手机号码')
          
          this.phone = ''
          return
      }



      
      if(!this.phone)return
      
      this.$http.post('/consultInfomationWebsite/saveConsultInfomation ',{name: this.name , telNumber:this.phone}).then(res=>{
        if(res&&res.data.code===1000){
            this.name = ''
            this.phone = ''
            this.$emit('update:display', false); // 触发事件通知父组件
            this.$message.success('请保持电话畅通,稍后会有专员联系您')
        }
      }).catch(err=>{

      })
    },
    closeDisplay () {
      this.$emit('update:display', false); // 触发事件通知父组件
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  width: 480px;
  height: 437px;
  background-color: white;
  padding: 44px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 16px;
  position: relative;
}
.modal i {
  position: absolute ;
  top: 20px;
  right: 39px;
  font-size: 30px;
  cursor: pointer;
}

.modal h3 {
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 32px;
  color: #3F3F3F;
  line-height: 45px;
}

.modal p {
  font-weight: 500;
  font-size: 14px;
  color: #3F3F3F;
  line-height: 24px;
  text-align: left;
}

.modal input {
  display: block;
  margin: 24px auto;
  padding: 15px;
  width: 392px;
  height: 56px;
  background: #FFFFFF;
  border-radius: 3px;
  border: 1px solid #D8D8D8;
  box-sizing: border-box;
  outline: none;
}
.modal input::placeholder {
  color: rgba(103, 169, 255, 1)
}

.modal button {
  width: 392px;
  height: 48px;
  background: #579DFD;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  color: #fff;
}
.modal button:hover {
  background-color: #2558b3;
}
</style>
  


// WEBPACK FOOTER //
// src/components/popUp.vue